/**
 * @file environment.staging.ts
 * @description Staging environment configuration — a production-optimized
 * build deployed to dev.kirigami.ai that talks to the dev backends.
 *
 * Use this to validate the production build pipeline end-to-end (hashing,
 * minification, budgets, SSR/hydration if/when enabled) against the dev
 * backends before promoting to real production.
 *
 * Swapped in for `environment.ts` when the `staging` Angular configuration
 * is selected (see `project.json` fileReplacements).
 *
 * Cognito pool IDs and auth domain are public identifiers (safe to commit).
 * The Paddle token is a sandbox token — replace with a real staging token
 * if/when staging-specific Paddle testing is required.
 */
import type { Environment } from './environment.model';

export const environment: Environment = {
  stage: 'staging',
  production: true,
  apiBaseUrl: 'https://api-dev.kirigami.ai/v1',
  kbapiBaseUrl: 'https://kbapi-dev.kirigami.ai/v1',
  gtm_id: 'GTM-KGZTTFW3',
  cognito: {
    userPoolId: 'eu-west-1_SY9uhVt9d',
    pubClientId: '2b26824ucicbcs2qdppkm198vc',
    priClientId: '1ssosn0nhc11m4u9s9ugb80gpb',
    region: 'eu-west-1',
    domain: 'auth-dev.kirigami.ai',
    responseType: 'code',
    scope: 'email openid profile phone aws.cognito.signin.user.admin',
  },
  paddle: {
    token: 'test_43b302f4f1790bad59320f529ba',
    priceId_1: 'pri_01kpv071sdwgksfgxzr44e4yry',
    priceId_2: 'pri_01k82xw4njskpe54gzsv96srtd',
    priceId_3: 'pri_01k82xxmwzrebqsb40g6qpa0kj',
    // Subscription plans (Paddle SANDBOX — same test token as dev). Monthly + annual.
    priceId_researcher_monthly: 'pri_01kvakb4db8v8j7s0gzcm1qr9y', // $20/mo
    priceId_researcher_annual: 'pri_01kvv6z0r69h3m9hcxvs76nx16', // $216/yr
    priceId_researcher_pro_monthly: 'pri_01kvv7cb4nvamvy03x5te1p90y', // $35/mo
    priceId_researcher_pro_annual: 'pri_01kvv7grrhwg5xw0yakx1ftgyg', // $378/yr
    priceId_mini_lab_monthly: 'pri_01kvv7p68xke1dz3cy58vn81m1', // $70/mo
    priceId_mini_lab_annual: 'pri_01kvv7t4rrsk4223c5j3etgqw0', // $168/yr
  },
};
